<template>
  <div ref="fileUpload" class="file-upload"
       :style="{maxHeight:multiple?'300px':false}">
    <div :class="{wrapper:!simpleView}" v-if="displayUpload">
      <div ref="drop" :class="{drop:!simpleView}">
        <div v-if="!simpleView" ref="cont" class="cont" style="color: rgb(142, 153, 165);">
          <i class="fa fa-cloud-upload"></i>
          <div class="tit" v-lang.drag_drop></div>
          <div class="desc">
            {{translate('accepted_extensions')}}: {{acceptedExtensions.join(', ')}}
          </div>
          <div class="browse" v-lang.click_here_to_browse></div>
        </div>
        <template v-else>
          <button @click.prevent="$refs.input.click()" v-lang.upload_file></button>
          <a href=""></a>
        </template>
        <input ref="input" class="ignore-validate" :class="{files:!simpleView}"
               :multiple="multiple" :disabled="disabled" name="files[]"
               type="file"
               @dragenter="dragenterHandler"
               @dragleave="dragleaveHandler" @change="onFileChange">
      </div>
    </div>
    <div class="output" :style="{maxHeight:multiple?'150px':false,textAlign: multiple||simpleView?false:'center'}">
      <output v-if="multiple" ref="list" class="list">
        <div v-for="(selectedFile,index) in selectedFiles" v-if="selectedFile.isActive">
          <div class="list-item">
            <div class="thumb">
              <div class="pl-0" @click="downloadFileFromIndex(index)" style="width:100%;cursor: pointer">
                <img v-if="selectedFile.status===fileStatuses.uploaded" class="image" :src="selectedFile.data"
                     :title="selectedFile.title">
                <progress-ring v-if="selectedFile.status===fileStatuses.uploading" :min="0" :max="101"
                               :value="selectedFile.percent" :text="'%'+selectedFile.percent"
                               height="75" width="75"></progress-ring>
                <a style="margin-left: 5px;">{{selectedFile.title}}</a>
              </div>
              <button v-if="displayUpload" :disabled="disabled" type="button" aria-label="Close" class="close"
                      @click="removeFile(index)"><span>×</span></button>
            </div>
          </div>
        </div>
      </output>
      <output v-else>
        <template v-if="selectedFiles[0] && selectedFiles[0].isActive">
          <div @click="downloadFileFromIndex(0)" style="cursor: pointer"
               :style="{width:simpleView?false:'100%',display:simpleView?'inline-block':false}">
            <img v-if="selectedFiles[0].status===fileStatuses.uploaded&&!simpleView"
                 :class="{'image-max-height':selectedFiles[0].type.match('image.*'),'thumb':!selectedFiles[0].type.match('image.*')}"
                 :src="selectedFiles[0].data"
                 :title="selectedFiles[0].title">
            <progress-ring v-if="selectedFiles[0].status===fileStatuses.uploading" :min="0" :max="101"
                           :value="selectedFiles[0].percent" :text="'%'+selectedFiles[0].percent"
                           height="75" width="75"></progress-ring>
            <a :style="{display: simpleView?false:'block'}">{{selectedFiles[0].title}}</a>
          </div>
          <button v-if="displayUpload" :disabled="disabled" type="button" aria-label="Close" class="close-single"
                  @click="removeFile(0)"><span>×</span></button>
        </template>
      </output>
    </div>
  </div>

</template>
<script>
import Vue from 'vue';
import * as api from '../../scripts/services/api';
import progressRing from './progressRing';
import * as blockui from '../../helpers/block-ui';
import {
  baseUrl,
} from '../../scripts/services/api';

export default {
  components: { progressRing },
  props: {
    value: {
      type: [Object, Array],
    },
    maxFileSize: {
      default: 20,
    },
    fileType: {
      type: String,
      default: 'all',
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    displayUpload: {
      type: Boolean,
      default: true,
    },
    isUploadBusy: {
      type: Boolean,
    },
    simpleView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fileTypeList: [],
      acceptedExtensions: [],
      selectedFiles: [],
      fileStatuses: {
        uploading: 1,
        uploaded: 2,
        canceled: 3,
        error: 4,
        deleted: 5,
      },
      dummyImage: 'data:image/png;base64,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',
    };
  },
  methods: {
    dragenterHandler(e) {
      if (!this.simpleView) {
        $(this.$refs.drop).css({
          border: '4px dashed #09f',
          background: 'rgba(0, 153, 255, .05)',
        });
        $(this.$refs.cont).css({
          color: '#09f',
        });
      }
    },
    dragleaveHandler(e) {
      if (!this.simpleView) {
        $(this.$refs.drop).css({
          border: '3px dashed #DADFE3',
          background: 'transparent',
        });
        $(this.$refs.cont).css({
          color: '#8E99A5',
        });
      }
    },
    onFileChange(evt) {
      const self = this;
      this.dragleaveHandler();
      const { files } = evt.target;
      if (self.multiple) {
        for (let i = 0, f; f = files[i]; i++) {
          self.uploadFile(f);
        }
      } else {
        try {
          if (!files) {
            throw new Error();
          }
          if (files.length !== 1) {
            throw new Error('Unable to upload mulitple file.');
          }
          self.uploadFile(files[0]);
        } catch (e) {
          toastr.error(e);
        }
      }
      $(this.$refs.input).val(null);
    },
    async uploadFile(f) {
      const self = this;
      const fileSize = ((f.size / 1024) / 1024).toFixed(4);
      const extension = f.name.split('.').pop().toLowerCase();
      if (typeof f.name !== undefined && fileSize <= this.maxFileSize && this.acceptedExtensions.includes(extension)) {
        let newFile = null;
        if (!f.type.match('image.*')) {
          newFile = {
            data: self.dummyImage,
            title: f.name,
            status: self.fileStatuses.uploading,
            percent: 0,
            xhr: null,
            type: f.type,
            isActive: true,
            isLocal: false,
          };
        } else {
          const rf = await self.readFile(f);
          newFile = {
            data: rf,
            title: f.name,
            status: self.fileStatuses.uploading,
            percent: 0,
            xhr: null,
            type: f.type,
            isActive: true,
            isLocal: true,
          };
        }

        let index;
        if (self.multiple) {
          index = self.selectedFiles.push(newFile) - 1;
        } else {
          index = 0;
          if (self.selectedFiles && self.selectedFiles.length > 0) {
            const temp = self.selectedFiles[0];
            if (temp.status === self.fileStatuses.uploading && !jQuery.isEmptyObject(temp.xhr)) {
              temp.xhr.abort();
            }
          }
          self.selectedFiles.splice(0, self.selectedFiles.length);
          self.selectedFiles.push(newFile);
        }

        const formData = new FormData();
        formData.append('File', f);
        formData.append('Id', 0);
        await Vue.http.post(`${baseUrl}/File/SaveFile`, formData, {
          progress(a) {
            if (a && a.lengthComputable) {
              const temp = self.selectedFiles[index];
              temp.percent = Number((a.loaded / a.total * 100).toFixed(1));
              Vue.set(self.selectedFiles, index, temp);
            }
          },
          before(xhr) {
            self.dragleaveHandler();
            const temp = self.selectedFiles[index];
            temp.xhr = xhr;
            Vue.set(self.selectedFiles, index, temp);
          },
        }).then((res) => {
          if (res.body.IsSuccess) {
            const temp = self.selectedFiles[index];
            temp.fileId = res.body.Message;
            temp.status = self.fileStatuses.uploaded;
            Vue.set(self.selectedFiles, index, temp);
            self.updateValue();
          } else {
            const temp = self.selectedFiles[index];
            temp.status = self.fileStatuses.error;
            temp.isActive = false;
            Vue.set(self.selectedFiles, index, temp);
            toastr.warning(res.body.Message);
          }
        }, (exception) => {
          const temp = self.selectedFiles[index];
          temp.status = self.fileStatuses.error;
          temp.isActive = false;
          Vue.set(self.selectedFiles, index, temp);
          toastr.warning(exception.body.Message);
        });
      } else {
        toastr.error(this.translate('file_is_not_suitable'));
      }
    },
    async readFile(f) {
      return new Promise(((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function (e) {
          resolve(e.target.result);
        };
        reader.onerror = function (err) {
          console.error('Failed to read', f.name, 'due to', err);
        };
        reader.readAsDataURL(f);
      }));
    },
    removeFile(index) {
      const self = this;
      const temp = self.selectedFiles[index];
      if (temp.status === self.fileStatuses.uploading && !jQuery.isEmptyObject(temp.xhr)) {
        temp.xhr.abort();
        temp.status = self.fileStatuses.canceled;
      } else {
        temp.status = self.fileStatuses.deleted;
      }
      temp.isActive = false;
      Vue.set(self.selectedFiles, index, temp);
      self.updateValue();
    },
    async downloadFileFromIndex(index) {
      const self = this;
      if (self.selectedFiles[index].isLocal) {
        const splitedFileData = self.selectedFiles[index].data.split(',');
        self.downloadBlob(self.base64toBlob(splitedFileData[1], self.selectedFiles[index].type), self.selectedFiles[index].title);
      } else if (self.selectedFiles[index].fileId > 0) {
        const response = await self.downloadFile(self.selectedFiles[index].fileId);
        const tempFile = self.selectedFiles[index];
        if (tempFile.type.match('image.*')) {
          tempFile.title = response.Name;
          tempFile.data = `data:${response.ContentType};base64,${response.Base64}`;
          tempFile.isLocal = true;
          tempFile.status = self.fileStatuses.uploaded;
          Vue.set(self.selectedFiles, index, tempFile);
        } else {
          self.downloadBlob(self.base64toBlob(response.Base64, response.ContentType), response.Name);
        }
      } else {
        toastr.error('file not found');
      }
    },
    async downloadImages() {
      const self = this;
      const promises = [];
      self.selectedFiles.forEach((selectedFile, index) => {
        if (selectedFile.fileId > 0 && !(selectedFile.isLocal) && selectedFile.type.match('image.*')) {
          const promise = new Promise(async (resolve, reject) => {
            const response = await self.downloadFile(selectedFile.fileId);
            selectedFile.title = response.Name;
            selectedFile.data = `data:${response.ContentType};base64,${response.Base64}`;
            selectedFile.isLocal = true;
            selectedFile.status = self.fileStatuses.uploaded;
            resolve(true);
          });
          promises.push(promise);
        }
      });
      if (promises.length > 0) {
        this.$emit('isDownloadBusy', true);
        await Promise.all(promises);
        this.$emit('isDownloadBusy', false);
      }
    },
    async downloadFile(fileId) {
      const self = this;
      blockui.blockModal(self);
      const response = await api.getFile({ id: fileId, isContainsData: true });
      // self.downloadBlob(self.base64toBlob(response.body.Data.Base64, response.body.Data.ContentType), response.body.Data.Name);
      blockui.unBlockModal();
      return response.body.Data;
    },
    base64toBlob(base64Data, type) {
      type = type || '';
      // Convert the Base64 string back to text.
      const byteString = atob(base64Data);

      // Convert that text into a byte array.
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], {
        type,
      });
    },
    downloadBlob(blob, fileName) {
      const a = $("<a style='display: none;'/>");
      const url = window.URL.createObjectURL(blob);
      a.attr('href', url);
      a.attr('download', fileName);
      $('body').append(a);
      a[0].click();
      window.URL.revokeObjectURL(url);
      a.remove();
    },
    getAllTypes() {
      api.getFileTypeList().then((response) => {
        this.fileTypeList = response.body;
        this.fileTypeList.forEach((fileType) => {
          this.acceptedExtensions.push(fileType.Extension);
        });
      });
    },
    getImageTypes() {
      // api.getImageTypeList().then(response => {
      // this.fileTypeList = response.body.Data;
      this.fileTypeList = [{
        Id: 1,
        Name: 'Image',
        Extension: 'jpeg',
        CompanyId: 1,
      }, {
        Id: 10,
        Name: 'Image',
        Extension: 'png',
        CompanyId: 1,
      }, {
        Id: 13,
        Name: 'Image',
        Extension: 'jpg',
        CompanyId: 1,
      }];
      this.fileTypeList.forEach((fileType) => {
        this.acceptedExtensions.push(fileType.Extension);
      });
      // });
    },
    updateValue() {
      const self = this;
      if (!self.isTransactionWorking) {
        const filteredFiles = self.selectedFiles.filter((selectedFile) => selectedFile.isActive && selectedFile.status === self.fileStatuses.uploaded && selectedFile.fileId > 0);
        if (self.multiple) {
          self.$emit('update:value', filteredFiles);
        } else {
          self.$emit('update:value', filteredFiles[0]);
        }
      }
    },
    setSelectedFiles(e) {
      const self = this;
      if (self.multiple) {
        if (Array.isArray(e)) {
          self.selectedFiles = e.map((x) => {
            if (x.data) {
              return x;
            }
            return {
              ...x,
              data: self.dummyImage,
            };
          });
        }
      } else if (e && !jQuery.isEmptyObject(e)) {
        if (e.data) {
          Vue.set(self.selectedFiles, 0, e);
        } else {
          Vue.set(self.selectedFiles, 0, {
            ...e,
            data: self.dummyImage,
          });
        }
      } else {
        Vue.delete(self.selectedFiles, 0);
      }
      self.downloadImages();
    },
  },
  computed: {
    isTransactionWorking() {
      const self = this;
      return this.selectedFiles.some((x) => x.status === self.fileStatuses.uploading && !jQuery.isEmptyObject(x.xhr));
    },
  },
  watch: {
    isTransactionWorking(e) {
      this.$emit('update:isUploadBusy', e);
    },
    value(e) {
      const self = this;
      /* if (e === {}) {
          self.setSelectedFiles(e);
        } */
      self.setSelectedFiles(e);
    },
  },
  mounted() {
    const self = this;
    self.setSelectedFiles(self.value);
  },
  created() {
    this.file = this.fileObj;
    if (this.fileType == 'Image') {
      this.getImageTypes();
    } else {
      this.getAllTypes();
    }
    this.selectedFile = this.image;
  },
};

</script>
<style lang="scss">
  .file-upload {
    position: relative;
    width: 100%;

    .output {
      width: 100%;
    }

    .wrapper {
      width: 100%;
      height: 150px;
    }

    .drop {
      width: 100%;
      max-height: 140px;
      border-radius: 15px;
      overflow: hidden;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      border: 3px dashed rgb(218, 223, 227);
      background: transparent;
    }

    .cont {
      width: 100%;
      height: 170px;
      color: #8E99A5;
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }

    i {
      font-size: 400%;
      color: #8E99A5;
      position: relative;
    }

    .tit {
      font-size: 200%;
      text-transform: uppercase;
    }

    .desc {
      color: #A4AEBB;
    }

    .browse {
      margin: 10px 25%;
      color: white;
      padding: 8px 16px;
      border-radius: 5px;
      background: #09f;
    }

    input {
      opacity: 0;
      display: none;
    }

    .files {
      display: inline-block;
      width: 100%;
      height: 100%;
      cursor: pointer;
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }

    .simple-files {
      width: 0.1px;
      height: 0.1px;
      opacity: 0;
      overflow: hidden;
      position: absolute;
      z-index: -1;
    }

    .list {
      width: 100%;
      text-align: left;
      overflow: auto;
      max-height: 150px;
      position: relative;
    }

    .thumb {
      height: 75px;
      border: 1px solid #323a44;
      position: relative;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      margin-top: 10px;
      margin-left: auto;
      margin-right: auto;

      .pl-0 {
        display: contents;
      }

      a {
        word-break: break-word;
      }
    }

    .image {
      height: 73px;
    }

    .image-max-height {
      max-height: 200px;
    }

    .close {
      height: 5.1rem;
      width: 5.1rem;
      -webkit-box-flex: 0;
      -ms-flex: 0 0 5.1rem;
      flex: 0 0 5.1rem;
      padding: 0;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      margin: 0 0 0 auto;
      border-left: 1px solid black;
    }

    .close-single {
      &:hover {
        color: #000;
        text-decoration: none;
        opacity: .75
      }

      background-color: transparent;
      border: 0;
      -webkit-appearance: button;
      font-size: 2.0rem;
      font-weight: 700;
      line-height: 1;
      color: #000;
      text-shadow: 0 1px 0 #fff;
      opacity: .5;
      outline: none !important;
      text-transform: none;
      overflow: visible;
      height: 3.1rem;
      width: 3.1rem;
      padding: 0;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      cursor: pointer;
    }
  }

</style>
